<template>
  <div class="page page-full user-list-page">
    <div class="page-header with-actions">
      <h1>Providers</h1>
      <div class="actions">
        <b-btn @click="createProvider" variant="success">
          Add New Provider
        </b-btn>
      </div>
    </div>
    <dt-datatable ref="providerList"
                  :id="tableId"
                  url="/admin/providersList"
                  :columns="columns"
                  :dt-options="dtOptions">
      <template #states="{ data }">
        <div v-for="(state, index) in data.states" :key="index">
          {{ state.name }}<span v-if="index != data.states.length - 1">, </span>
        </div>
      </template>
      <template #actions="{ data }">
        <div>
          <a class="btn btn-link pl-0 text-success" @click="editCoupon(data.id)">Edit</a>
          <a class="btn btn-link text-danger" @click="showModalDelete(data.id)">Delete</a>
        </div>
      </template>
    </dt-datatable>

    <b-modal ref="modalDelete"
             cancel-variant="outline-secondary"
             ok-variant="success"
             @ok="deleteProvider"
             title="Confirm">
      Are you sure you want to delete this provider?
    </b-modal>
    <create-edit-provider-modal ref="createEditProviderModal" @onSuccess="providerCreatedEdited"></create-edit-provider-modal>
  </div>
</template>

<script>
  import CreateEditProviderModal from "./create-edit-provider-modal";
  import employeeService from "services/employee-service";

  export default {
    components: {
      CreateEditProviderModal
    },

    data() {
      return {
        tableId: `provider-list-id${this.$auth.id}`,
        roleFilterOptions: [],
        columns: [
          { name: "Id" },
          { name: "FirstName", sortable: true, searchable: false },
          { name: "LastName", sortable: true, searchable: false },
          { name: "PhysicianNpi", sortable: false, searchable: false},
          { name: "States", sortable: false, searchable: false },
          { name: "Actions", data: false }
        ],
        dtOptions: {
          order: [[0, "asc"]],
          columnDefs: [
            { width: "30px", targets: 0 },
            { width: "15%", targets: 3 }
          ]
        },
        providerToDeleteId: null,
      };
    },

    methods: {
      createProvider() {
        this.$refs.createEditProviderModal.show();
      },

      providerCreatedEdited(id) {
        this.redrawTable();

        if (!id)
          this.$root.successToast("Provider created");
        else
          this.$root.successToast("Provider edited");
      },

      redrawTable() {
        this.$refs.providerList.draw();
      },

      showModalDelete(id) {
        this.providerToDeleteId = id;
        this.$refs.modalDelete.show();
      },

      async deleteProvider() {
        await employeeService.delete(this.providerToDeleteId);

        this.$root.successToast("Provider deleted!");
        this.redrawTable();
      },

      editCoupon(id) {
        this.$refs.createEditProviderModal.show(id);
      }
    },
  };
</script>